import { OverlayPanel } from 'primereact/overlaypanel';
import { FC, useRef } from 'react';
import { GoalValue } from './WeeklyGoalWrapper';
import { Link } from 'react-router-dom';
import WeeklyGoalCoreSkillList from './WeeklyGoalCoreSkillList';
import { scrollToUnitPathPositionWhenReady } from '../../custom-hooks/useUnitPathPositionAnchor';

interface Props {
  goalValues: GoalValue[] | null;
  refOp: React.RefObject<OverlayPanel>;
  triggerCenterRef: React.RefObject<HTMLButtonElement | null>;
}

const WeeklyGoalCorePanel: FC<Props> = ({ goalValues, refOp, triggerCenterRef }) => {
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const principalMessage = () => {
    if (goalValues?.length === 0) return "Seems like you haven't passed any skill yet this week...";
    if (goalValues?.length === 1) return 'Getting closer to your weekly goal!';
    if (goalValues?.length === 2) return 'You´ve already reached your goal this week!';
    if (goalValues?.length && goalValues?.length >= 3) return 'You´ve exceeded your goal. Go you!';
  };

  return (
    <OverlayPanel
      ref={refOp}
      onShow={() => {
        linkRef.current?.focus();
      }}
      onHide={() => {
        triggerCenterRef.current?.focus();
      }}
    >
      <div
        className={`tw-bg-stone-0 tw-flex tw-flex-col tw-color-stone-0 tw-p-3 tw-gap-y-3 ${
          !goalValues?.length ? 'tw-items-center' : ''
        }`}
      >
        <h2 className="tw-text-lg tw-font-atkinson tw-font-normal tw-not-italic tw-max-w-xs tw-text-center">
          {principalMessage()}
        </h2>
        {goalValues?.length === 0 ? (
          <Link
            ref={linkRef}
            to={'/'}
            onClick={e => {
              refOp.current?.toggle(e);
              // The skills are no longer a list at the bottom of the page but a path of connected
              // cards, so "Give me a skill" lands the student on their current position on that path —
              // the same target the dashboard scrolls to on entry. The wait covers arriving from
              // another route, where the path has not rendered yet at click time.
              scrollToUnitPathPositionWhenReady();
            }}
            className="tw-font-xs tw-font-bold tw-font-atkinson"
            tabIndex={0}
            aria-label="Give me a skill"
          >
            Give me a skill
          </Link>
        ) : (
          <>
            <h2 className="tw-text-sm tw-font-bold tw-font-atkinson tw-not-italic">Passed skills:</h2>
            <ul className="tw-p-0 tw-m-0">
              {goalValues?.map((el, index) => {
                return (
                  <li key={index} className="tw-flex tw-flex-row tw-gap-x-2">
                    <WeeklyGoalCoreSkillList item={el} />
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>
    </OverlayPanel>
  );
};

export default WeeklyGoalCorePanel;
